export default Object.freeze({
    MONTH: 'month',
});
